import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('../views/BusinessView.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsView.vue')
  },
  {
    path: '/fabrication',
    name: 'fabrication',
    component: () => import('../views/Fabrication.vue')
  },
  {
    path: '/project-highlights',
    name: 'project-highlights',
    component: () => import('../views/Project-highlights.vue')
  },
  {
    path: '/media',
    name: 'media',
    component: () => import('../views/MediaView.vue')
  },
  {
    path: '/media-detail',
    name: 'media-detail',
    component: () => import('../views/MediaDetailView.vue')
  },
  {
    path: '/media-key',
    name: 'media-key',
    component: () => import('../views/MediaKeyView.vue')
  },
  {
    path: '/esg',
    name: 'esg',
    component: () => import('../views/ESGView.vue')
  },
  {
    path: '/hr',
    name: 'hr',
    component: () => import('../views/HRView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return
    }
    return { x: 0, y: 0 }
  }
})

export default router
